module.exports = __webpack_public_path__ + "img/icons/new/dropdown-pb-40a3840a74e63f5f2cf321f966508488.svg";